import isEqual from 'lodash/isEqual';

export const PENDING_STAB = { __pending: true };
export const EMPTY_STAB = { __empty: true };

export const isPendingStab = state => isEqual(state, PENDING_STAB);
export const isEmptyStab = state => isEqual(state, EMPTY_STAB);



// WEBPACK FOOTER //
// ./src/utils/stab.js